<h1>Lessons Learnt / Best Practices

  <div class="lessons-learnt-buttons">

    <button
      mat-button
      (click)="openAddDialog()"
      class="btnNeutral"
      type="button">
      Add Lesson Learnt
    </button>

    <button
      mat-button
      (click)="downloadFiltersLessonsLearnt()"
      class="btnNeutral"
      [disabled]="!canDownloadExcel()"
      type="button">
      Download as Excel
    </button>
  </div>
</h1>
<mat-accordion>
  <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="filter">
      <digires-multi-list-input
        [formGroup]="formGroup"
        [items]="allCountryIds"
        [allItemName]="'All Countries'"
        formCtrlName="countryCodes"
        placeholder="Country / Countries"
        tooltip="This Item will be applicable to projects in this Country/Countries"
        [itemToLabel]="countryToLabel"
        [multiSelect]="true"
      ></digires-multi-list-input>

      <digires-user-input
        [formGroup]="formGroup"
        formCtrlName="authorUserId"
        placeholder="Author of Item"
        tooltip="The name of the person who has entered the Item into the Lessons Learnt register"
      ></digires-user-input>

      <digires-user-input
        [formGroup]="formGroup"
        formCtrlName="identifierUserId"
        placeholder="Identifier of Item"
        tooltip="The name of the person who have identified the Item"
      ></digires-user-input>

      <digires-multi-list-input
        [formGroup]="formGroup"
        [items]="allDiscussedInTeamOptions"
        [allItemName]="'All'"
        formCtrlName="discussedInTeam"
        placeholder="Discussed in Integrated Project Team"
        tooltip="The relevant members of the Integrated Project Team have been involved in discussions about this matter"
        [itemToLabel]="discussedInTeamToLabel"
        [multiSelect]="true"
      ></digires-multi-list-input>

      <digires-multi-list-input
        [formGroup]="formGroup"
        [items]="allLessonLearntBestPracticeOptions"
        [allItemName]="'All'"
        formCtrlName="lessonsLearnedBestPractice"
        placeholder="Lesson Learnt / Best Practice"
        tooltip="Identifies if the Item relates to a Lesson Learnt (i.e. experiences distilled from past activities that should be actively taken into account to inform future actions and behaviours therefore being adopted through Continuous Improvement of our ways of working) or symbolises Best Practice (i.e. optimal performance of the organisation through the application of the most effective ways of working)"
        [itemToLabel]="lessonLearntBestPracticeToLabel"
        [multiSelect]="true"
      ></digires-multi-list-input>

      <digires-multi-dropdown-input
        [formGroup]="formGroup"
        [configId]="'lessons-learnt-status'"
        [allItemName]="'All Status'"
        formCtrlName="status"
        placeholder="Status"
        tooltip="'Active' shows those that are Active (i.e. Status: Identification, Consideration, Implementation); and 'Inactive' shows those that are Inactive (i.e. Status: Archived.)'"
      ></digires-multi-dropdown-input>

      <digires-dropdown-input
        configId="lessons-learnt-applicableTo"
        [formGroup]="formGroup"
        formCtrlName="applicableTo"
        placeholder="Applicable To"
        tooltip="This identifies what scope the Item has in terms of how widely it is applicable"
      ></digires-dropdown-input>

      <digires-multi-list-input
        [formGroup]="formGroup"
        [items]="projectPhases"
        [allItemName]="'All Project Phases'"
        formCtrlName="projectPhase"
        placeholder="Project Phase"
        tooltip="The Project Phase relates to the current phase of the project's life cycle: Development; Construction or Operations."
        [itemToLabel]="phaseToLabel"
        [multiSelect]="true"
      ></digires-multi-list-input>

      <digires-multi-list-input
        [formGroup]="formGroup"
        [items]="projectStages"
        [allItemName]="'All Project Stages'"
        formCtrlName="projectStage"
        placeholder="Project Stage"
        tooltip="The Project Stage relates to the current stage of the project's life cycle during the Development Phase: 1. Origination; 2. Early Development; 3. Mid-Development; 4. Late Development; 5. Ready for FID (5a. Post FID (Conditionally); 5b. Post FID (Fully Secured)); N/A in Construction; or N/A in Operations."
        [itemToLabel]="stageToLabel"
        [multiSelect]="true"
      ></digires-multi-list-input>

      <!-- <digires-multi-list-input
        [formGroup]="formGroup"
        [items]="allCategoriesOptionsIds"
        [allItemName]="'All Categories'"
        formCtrlName="categories"
        placeholder="Categories"
        tooltip="This identifies the relevant categories that the Item is applicable to."
        [itemToLabel]="categoryToLabel.bind(this)"
        [multiSelect]="true"
      ></digires-multi-list-input> -->

      <digires-multi-dropdown-input
        [configId]="['lessons-learnt-categories-development', 'lessons-learnt-categories-construction']"
        [formGroup]="formGroup"
        [allItemName]="'All Categories'"
        formCtrlName="categories"
        placeholder="Categories"
        tooltip="This identifies the relevant categories that the Item is applicable to."
      ></digires-multi-dropdown-input>

      <digires-multi-list-input
        id="technologies"
        [formGroup]="formGroup"
        [items]="technologies"
        [allItemName]="'All Technologies'"
        formCtrlName="technologies"
        placeholder="Technologies"
        tooltip="The relevant technologies for this Lesson Learnt"
        [itemToLabel]="technologyToLabel"
        [multiSelect]="true"
      ></digires-multi-list-input>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<div class="table-container">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div style="padding-right: 10px">
          {{column.header}}
        </div>
        <mat-icon
          class="tooltip-icon"
          matTooltipPosition="above"
          [matTooltip]="column.tooltip"
          svgIcon="tooltip"
        ></mat-icon>
      </th>
      <td mat-cell *matCellDef="let row" [innerHTML]="column.cell(row)" (click)="openLessonLearnt(row, column.columnDef)">
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
  </table>
</div>

<div *ngIf="isLoading()" class="spinner_background">
  <mat-progress-spinner [diameter]=25 class="spinner" mode="indeterminate"></mat-progress-spinner>
  <div class="spinner_label">Loading Lessons Learnt, please wait...</div>
</div>
